/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Store from "@ember-data/store";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { isEmpty } from "@ember/utils";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { getNewExpectedDosages } from "core/components/bio-exam-results/utils/dosage-expected";
import getReferenceValuesMessage from "core/components/bio-exam-results/utils/reference-value-message";
import { ExpectedDosage } from "core/models/bio-exam-expected-dosage-changed-journal-event";
import BioExamResult from "core/models/bio-exam-result";
import BioExamObservation from "core/models/loinc";
import Patient from "core/models/patient";
import formatNumberAsString from "core/utils/format-number-as-string";
import trimLoincCode from "core/utils/trim-loinc-code";
import { Changeset, EmberChangeset } from "ember-changeset";
import lookupValidator from "ember-changeset-validations";
import { validateNumber } from "ember-changeset-validations/validators";
import IntlService from "ember-intl/services/intl";
import styles from "./component.module.css";
let BioExamGenericFieldComponent = (_class = class BioExamGenericFieldComponent extends Component {
  constructor(owner, args) {
    super(owner, args);

    // The auto-validation is disabled, and we call validate() only when losing the focus on the field
    // The @action onFocusOut
    _defineProperty(this, "styles", styles);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "store", _descriptor2, this);
    _initializerDefineProperty(this, "referenceValueChangeset", _descriptor3, this);
    _initializerDefineProperty(this, "shouldDisplayReferenceRange", _descriptor4, this);
    _initializerDefineProperty(this, "cleanedValue", _descriptor5, this);
    _initializerDefineProperty(this, "operator", _descriptor6, this);
    _defineProperty(this, "shouldDisplayOperator", void 0);
    this.referenceValueChangeset = Changeset({}, lookupValidator(this.validationObject), this.validationObject, {
      skipValidate: true
    });
    const result = this.args.changeset.get("results").find(res => res.code == this.propertyName);
    this.shouldDisplayOperator = result && result.operator != "equal-to";
    this.operator = result?.operator;
  }
  get loinc() {
    return this.args.bioExamObservation.loinc;
  }
  get valueType() {
    return this.args.bioExamObservation.valueType;
  }
  get referenceValuesMessage() {
    return this.args.bioExamObservation.referenceValuesMessage;
  }
  get propertyName() {
    return `LOINC-${this.loinc}`;
  }
  get expectedDosage() {
    const newExpectedDosages = getNewExpectedDosages(this.args.patient);
    if (newExpectedDosages) {
      return newExpectedDosages[`LOINC-${this.loinc}`];
    }
    return undefined;
  }
  get minReferenceValue() {
    return this.expectedDosage?.min || this.args.bioExamObservation.minReferenceValue;
  }
  get maxReferenceValue() {
    return this.expectedDosage?.max || this.args.bioExamObservation.maxReferenceValue;
  }
  get referenceValues() {
    if (this.referenceValuesMessage) return this.referenceValuesMessage;
    return getReferenceValuesMessage({
      min: this.minReferenceValue,
      max: this.maxReferenceValue,
      prefix: "Valeurs de référence : "
    });
  }
  get isZeroable() {
    return this.args.bioExamObservation.zeroable;
  }
  get validationObject() {
    const referenceValuesValidations = [
    // The number validation is declared on the global form, to prevent the user to write anything that's not a number
    // We put it here also to avoid the validations below to be displayed at the same time because we don't to display
    // Both validations message (validations are tested in the declaration order, and only one is message displayed).
    validateNumber({
      string: true,
      allowBlank: true,
      message: " "
    })];
    if (!this.isZeroable) {
      referenceValuesValidations.push(validateNumber({
        gt: 0,
        allowBlank: true,
        message: "Cette valeur doit être supérieure à 0"
      }));
    }
    const validationObject = {};
    validationObject[this.propertyName] = referenceValuesValidations;
    return validationObject;
  }
  updateValue(event) {
    const target = event.target;
    this.args.changeset.set(this.propertyName, target.value);
    this.onChangesetUpdate(this.args.changeset);
  }
  updateOperator(operator) {
    const results = this.args.changeset.get("results");
    const existingResultIndex = results.findIndex(res => res.code == this.propertyName);
    const resultToUpdate = results[existingResultIndex];
    resultToUpdate.operator = operator;
    results[existingResultIndex] = resultToUpdate;
    this.args.changeset.set("results", [...results]);
    this.onChangesetUpdate(this.args.changeset);
  }
  onChangesetUpdate(value) {
    this.cleanedValue = formatNumberAsString(value.get(this.propertyName));
    this.referenceValueChangeset.set(this.propertyName, this.cleanedValue);
    const code = this.propertyName;
    const results = this.args.changeset.get("results");
    if (!code.startsWith("LOINC")) return;
    this.referenceValueChangeset.validate();
    const existingResultIndex = results?.findIndex(res => res.code == code);
    const existingResult = results[existingResultIndex];
    if (!existingResult) {
      const obs = this.store.peekRecord("loinc", trimLoincCode(code));
      const unit = obs.defaultUnit;
      const bioExamResult = this.args.changeset.get("isFromHprim") == true ? BioExamResult.newManualRes({
        store: this.store,
        code,
        value: this.cleanedValue,
        unit
      }) : new BioExamResult({
        store: this.store,
        code,
        value: this.cleanedValue,
        unit
      });
      results.push(bioExamResult);
      return;
    }
    if (existingResult.isManualMatching) {
      // Update raw value
      const segs = existingResult.resultHash.originalLine.raw.segs;
      segs[4] = this.cleanedValue;
    }
    if (existingResult.value == this.cleanedValue) return;
    if (isEmpty(this.cleanedValue)) {
      this.removeResultFromChangeset(existingResultIndex);
      return;
    }
    existingResult.value = this.cleanedValue;
  }
  removeResultFromChangeset(index) {
    const results = this.args.changeset.get("results");
    results.splice(index, 1);
    this.args.changeset.set("results", results);
  }
  onFocusOut() {
    if (!this.minReferenceValue && !this.maxReferenceValue) return;
    if (this.minReferenceValue > parseFloat(this.cleanedValue) || this.maxReferenceValue < parseFloat(this.cleanedValue)) {
      this.shouldDisplayReferenceRange = true;
      return;
    }
    this.shouldDisplayReferenceRange = false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "referenceValueChangeset", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "shouldDisplayReferenceRange", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "cleanedValue", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "operator", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "updateValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateOperator", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateOperator"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChangesetUpdate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChangesetUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onFocusOut", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onFocusOut"), _class.prototype), _class);
export { BioExamGenericFieldComponent as default };